import { React, useState, useEffect } from "react";
import "../index.css";

export default function FormPremisesDetails({
  form,
  premisesErrors,
  setPremisesErrors,
  setForm,
  product,
  products,
  nextStep,
  handleChange,
  prevStep,
  unexpectedError,
}) {
  const [isChecked, setIsChecked] = useState(!!form.additional_form);
  const [additionalForms, setAdditionalForms] = useState({});   

  var isSA00050 = product && product.form_code === "SA00050";

  useEffect(() => {
    const checkAdditional = () => {
      if (product.additional_forms && product.additional_forms.length) {
        product.additional_forms.forEach((id) => {
          let product = products.find((obj) => {
            return obj.template_id === id;
          });
          setAdditionalForms((prev) => {
            return { ...prev, [id]: product };
          });
        });
      }
    };

    checkAdditional();
  }, [products, product.additional_forms])

 
  const handleCheck = (e) => {
    setIsChecked((c) => {
      if (!c) {
        setForm((form) => {
          return { ...form, [e.target.name]: e.target.value };
        });
        return true;
      } else {
        setForm((form) => {
          return { ...form, [e.target.name]: null };
        });
        return false;
      }
    });
  };

  const handleSubmit = () => {
    !isSA00050 
    ? onSubmitHandler()
    : submitSA00050();
  }

  const submitSA00050 = () => {
    const errors = {};
    var passed = true;

    if (form.Principal_NameFull.trim() === "") {
      errors.Principal_NameFull = "Client 1 Name cannot be empty";
      passed = false;
    }

    if (form.Principal_NameFull.trim().length < 4) {
      errors.Principal_NameFull =
        "Client 1 Name cannot be less than 4 characters";
      passed = false;
    }

    if (form.Property_Location.trim() === "") {
      errors.Property_Location = "Location cannot be empty";
      passed = false;
    }

    if (form.Property_Location.trim().length < 4) {
      errors.Property_Location = "Location cannot be less than 4 characters";
      passed = false;
    }

    if (passed) {
      var formName = [
        form.Principal_NameFull, form.Property_Location
      ].join('');
  
      if (formName.match(/[^a-z0-9\s]{2}/i) || formName.length < 8) {
          errors.Property_Location = '"Location" must be a valid location';
      }
    }

    setPremisesErrors(errors);

    if (Object.keys(errors).length === 0) {
      if (isChecked) {
        products.filter((p) => {
          if (p.template_id === +form.additional_form) {
            setForm((form) => {
              return { ...form, additional_form: p };
            });
            return p;
          }

          return false;
        });
      }
      nextStep();
    }
  };

  const onSubmitHandler = async () => {
    const postcodeRegEx = new RegExp(/^[0-9]+$/);
    const errors = {};
    var passed = true;

    if (form.premises_address_line_1.trim() === "") {
      errors.premises_address_line_1 = "Address Line 1 cannot be empty";
      passed = false;
    }

    if (form.premises_address_line_1.trim().length < 4) {
      errors.premises_address_line_1 =
        "Address Line 1 cannot be less than 4 characters";
      passed = false;
    }

    if (form.premises_suburb.trim() === "") {
      errors.premises_suburb = "Suburb cannot be empty";
      passed = false;
    }

    if (form.premises_suburb.trim().length < 4) {
      errors.premises_suburb = "Suburb cannot be less than 4 characters";
      passed = false;
    }

    if (!postcodeRegEx.test(form.premises_postcode)) {
      errors.premises_postcode = "Postcode must be numeric";
      passed = false;
    }
    if (form.premises_postcode.trim() === "") {
      errors.premises_postcode = "Postcode cannot be empty";
      passed = false;
    }

    if (passed) {
      var formName = [
        form.premises_address_line_1, form.premises_address_line_2,
        form.premises_suburb, form.premises_state,
        form.premises_postcode
      ].join('');
  
      if (formName.match(/[^a-z0-9\s]{2}/i) || formName.length < 12) {
          errors.premises_address_line_1 = '"Premises address" must be a valid address';
          errors.premises_suburb = ' ';
          errors.premises_state = ' ';
          errors.premises_postcode = ' ';
      }
    }

    setPremisesErrors(errors);

    if (Object.keys(errors).length === 0) {
      if (isChecked) {
        products.filter((p) => {
          if (p.template_id === +form.additional_form) {
            setForm((form) => {
              return { ...form, additional_form: p };
            });
            return p;
          }

          return false;
        });
      }
      nextStep();
    }
  };

  

  return (
    <div>
      <h4 className="text-2xl font-semibold">Premises Details</h4>
      <p className="leading-relaxed mt-1 text-gray-600 mb-10">
        Enter the premises details for which the form is being created.
      </p>
      {
        !isSA00050 ?
        <form className="space-y-4 xs:w-[100%]">
        <div className="flex flex-wrap">
          <div className="w-full">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="premises_address_line_1"
            >
              Address Line 1 <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className={
                premisesErrors.premises_address_line_1
                  ? " border-red-500 border-x border-y px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
                  : "border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              }
              required
              placeholder="Address Line 1"
              name="premises_address_line_1"
              onChange={handleChange("premises_address_line_1")}
              defaultValue={form.premises_address_line_1}
            />
            <p className=" text-red-600 text-xs mt-2">
              {premisesErrors.premises_address_line_1}
            </p>
          </div>
        </div>
        <div className="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div className="w-full px-2">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="premises_address_line_2"
            >
              Address Line 2
            </label>
            <input
              type="text"
              className="border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              placeholder="Address Line 2"
              name="premises_address_line_2"
              onChange={handleChange("premises_address_line_2")}
              defaultValue={form.premises_address_line_2}
            />
          </div>
        </div>
        <div className="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div className="w-full px-2 md:w-1/2">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="premises_suburb"
            >
              Suburb <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className={
                premisesErrors.premises_suburb
                  ? " border-red-500 border-x border-y px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
                  : "border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              }
              placeholder="Suburb"
              name="premises_suburb"
              onChange={handleChange("premises_suburb")}
              defaultValue={form.premises_suburb}
            />
            <p className=" text-red-600 text-xs mt-2">
              {premisesErrors.premises_suburb}
            </p>
          </div>
          <div className="w-full px-2 md:w-1/4">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="premises_state"
            >
              State
            </label>
            <input
              disabled={true}
              type="text"
              className="border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              name="premises_state"
              defaultValue={form.premises_state}
            />
          </div>
          <div className="w-full px-2 md:w-1/4">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="premises_postcode"
            >
              Postcode <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              maxLength={4}
              className={
                premisesErrors.premises_postcode
                  ? " border-red-500 border-x border-y px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
                  : "border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              }
              placeholder="Postcode"
              name="premises_postCode"
              onChange={handleChange("premises_postcode")}
              defaultValue={form.premises_postcode}
            />
            <p className=" text-red-600 text-xs mt-2">
              {premisesErrors.premises_postcode}
            </p>
          </div>

           <div className="pt-8 px-2">
            {product.additional_forms?.length && Object.keys(additionalForms).length &&
              product.additional_forms.map((id, i) => {
                return (
                  <label key={i} className="items-center inline-flex">
                    <input
                      className="w-5 h-5"
                      checked={isChecked}
                      name="additional_form"
                      value={id} 
                      type="checkbox"
                      onChange={(e) => handleCheck(e)}
                    />
                    <span className="ml-3">
                      {`Add ${additionalForms[id].form_code} ${additionalForms[id].name}.`}
                      <span className="text-green-500 font-semibold ml-2">
                        +${((additionalForms[id].priceInCents + additionalForms[id].gst) / 100).toFixed(2)}
                      </span>
                    </span>
                  </label>
                );
              })}
          </div>
        </div>
      </form>
      : /* here */
      <form className="space-y-4 xs:w-[100%]">
        <div className="flex flex-wrap">
          <div className="w-full">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="premises_address_line_1"
            >
              Client 1 Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className={
                premisesErrors.Principal_NameFull
                  ? " border-red-500 border-x border-y px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
                  : "border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              }
              required
              placeholder="Client 1 Name"
              name="Principal_NameFull"
              onChange={handleChange("Principal_NameFull")}
              defaultValue={form.Principal_NameFull}
            />
            <p className=" text-red-600 text-xs mt-2">
              {premisesErrors.Principal_NameFull}
            </p>
          </div>
        </div>
        <div className="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div className="w-full px-2">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="Principal2_NameFull"
            >
              Client 2 Name
            </label>
            <input
              type="text"
              className="border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              placeholder="Client 2 Name"
              name="Principal2_NameFull"
              onChange={handleChange("Principal2_NameFull")}
              defaultValue={form.Principal2_NameFull}
            />
          </div>
        </div>

        <div className="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div className="w-full px-2">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="Property_Location"
            >
              Location <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Location"
              name="Property_Location"
              onChange={handleChange("Property_Location")}
              defaultValue={form.Property_Location}
              className={
                premisesErrors.Property_Location
                  ? " border-red-500 border-x border-y px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
                  : "border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              }
            />
            <p className=" text-red-600 text-xs mt-2">
              {premisesErrors.Property_Location}
            </p>
          </div>
        </div>
        <div className="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
           <div className="pt-8 px-2">
            {product.additional_forms?.length && Object.keys(additionalForms).length &&
              product.additional_forms.map((id, i) => {
                return (
                  <label key={i} className="items-center inline-flex">
                    <input
                      className="w-5 h-5"
                      checked={isChecked}
                      name="additional_form"
                      value={id} 
                      type="checkbox"
                      onChange={(e) => handleCheck(e)}
                    />
                    <span className="ml-3">
                      {`Add ${additionalForms[id].form_code} ${additionalForms[id].name}.`}
                      <span className="text-green-500 font-semibold ml-2">
                        +${((additionalForms[id].priceInCents + additionalForms[id].gst) / 100).toFixed(2)}
                      </span>
                    </span>
                  </label>
                );
              })}
          </div>
        </div>
      </form>
      }

      <div className="text-center flex justify-between mt-6">
        <button
          className="text-white bg-black focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
          type="button"
          onClick={prevStep}
        >
          Back
        </button>

        <button
          className="text-white bg-[#005b95] focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
          type="button"
          onClick={handleSubmit}
        >
          Next
        </button>
      </div>
      <p className={unexpectedError ? "text-red-600 text-s mt-2" : "hidden"}>
        {unexpectedError.message}
      </p>
    </div>
  );
}
